import { useState } from "react";
import { deleteSemester } from "../../_services/semester.service";

export const useDeleteSemester = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDeleteSemester = async (id, callback) => {
    setLoading(true);
    try {
      const response = await deleteSemester(id);
      setData(response);
      if (callback) callback();
    } catch (error) {
      console.error("Error deleting semester:", error);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, handleDeleteSemester };
};
